import { render } from "./organizationContact.vue?vue&type=template&id=82ab57f8"
import script from "./organizationContact.vue?vue&type=script&lang=js"
export * from "./organizationContact.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__